import { render, staticRenderFns } from "./mahjongLegacy.vue?vue&type=template&id=03f164a8&scoped=true"
import script from "./mahjongLegacy.vue?vue&type=script&lang=js"
export * from "./mahjongLegacy.vue?vue&type=script&lang=js"
import style0 from "./mahjongLegacy.vue?vue&type=style&index=0&id=03f164a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f164a8",
  null
  
)

export default component.exports